import { QueryStrings } from "./emitter-events.models";
import { ZoneEntity } from "./inspection.model";

export enum VIEW_CONTROLS {
	VIEW_RULE = "view_rule",
	VIEW_ASSET = "view_asset",
	CREATE_RULE = "create_rule",
	EDIT_RULE = "edit_rule",
}
export enum TripDefinition {
	AFTER_DISTANCE = "after_distance",
	ENTER_ZONE = "enter_zone",
	EXIT_ZONE = "exit_zone",
	POWER_OFF = "power_off",
	POWER_ON = "power_on",
}

export const EXCLUDED_ZONES = "excluded_zones";

export interface DisplayedZone extends ZoneEntity {
	checked?: boolean;
	divisionId?: string;
}
export interface DisplayedCategory extends Category {
	expanded?: boolean;
	zones?: DisplayedZone[];
	displayedZones?: DisplayedZone[];
	checked?: boolean;
}

export interface SelectedCategory {
	name: string;
	id: string;
	zones: DisplayedZone[];
}

export enum TripFrequency {
	TRIP = "trip",
	WORK_PERIOD = "work_period",
}
export interface TimeRange {
	hr: number;
	min: number;
}

export enum TRIP_NAMES {
	TRIP_START = "tripStart",
	TRIP_END = "tripEnd",
}

export interface InspectionType {
	inspectionType: string;
}

export interface WorkPeriod {
	days: number[];
	start: TimeRange;
	end: TimeRange;
}

export interface TripStartOrEnd {
	definition: TripDefinition;
	frequency: TripFrequency;
	inspectionTypes: InspectionType[];
	within: number;
	workPeriods: WorkPeriod[];
	zones: RuleZone[];
	detailedZones?: DisplayedZone[];
	timezone?: string;
}

export interface RuleZone {
	categoryId: string;
	zoneId: string;
}

export interface MirRuleHttp {
	id?: string;
	name: string;
	created: string;
	updated: string;
	companyId: string;
	active?: boolean;
	assets?: string[];
	excludeZones?: RuleZone[];
	timezone?: string;
	tripStart?: TripStartOrEnd;
	tripEnd?: TripStartOrEnd;
	lastUserId?: string;
	lastUserName?: string;
}

// export type MirRulePatchBody = Omit<MirRuleHttp, "created" | "updated" | "lastUserId" | "lastUserName">;

export interface MirRulePatchBody {
	id?: string;
	name: string;
	companyId?: string;
	active?: boolean;
	assets?: string[];
	excludedZones?: RuleZone[];
	timezone?: string;
	tripStart?: TripStartOrEnd;
	tripEnd?: TripStartOrEnd;
}

export interface MirRule {
	name: string;
	byUser: string;
	assignedAssets: number;
	updated: string;
	id: string;
	excludedZones?: RuleZone[];
	detailedExcludedZones?: DisplayedZone[];
	tripStart?: TripStartOrEnd;
	tripEnd?: TripStartOrEnd;
	companyId?: string;
	disableCheckbox?: boolean;
	assets?: string[];
}

export interface RuleApiParams extends QueryStrings {
	name?: string;
	userName?: string;
}

export interface AssetRuleApiParams extends QueryStrings {
	assetId?: string;
	assetName?: string;
	ruleId?: string;
	ruleIds?: string[];
	ruleName?: string;
	divisionId?: string;
	divisionName?: string;
	companyId?: string;
	search?: string;
}

export interface AssetRulePatchAddRuleBody {
	[key: string]: {
		add: string[];
	};
}

export interface AssetRulePatchRemoveRuleBody {
	[key: string]: {
		remove: string[];
	};
}

export class AssetRulePatchBody {
	constructor(
		companyId: string,
		removedRules: AssetRulePatchRemoveRuleBody,
		addedRules: AssetRulePatchAddRuleBody = null,
	) {
		this.addedRules = addedRules;
		this.removedRules = removedRules;
		this.companyId = companyId;
	}

	addedRules: AssetRulePatchAddRuleBody;
	removedRules: AssetRulePatchRemoveRuleBody;
	companyId: string;
	assetRules = {};

	private _getAssetRules() {
		if (this.addedRules) {
			this.assetRules = {
				...this.addedRules,
			};
		}

		if (this.removedRules) {
			this.assetRules = {
				...this.assetRules,
				...this.removedRules,
			};
		}

		return this.assetRules;
	}

	get body() {
		this._getAssetRules();
		return {
			companyId: this.companyId,
			assetRules: this.assetRules,
		};
	}
}

export interface AssetRuleForTable extends AssetRuleApiParams {
	rule?: MirRule;
}

export interface Division {
	active: boolean;
	divisionId: string;
	divisionName: string;
	divisionType: string;
}
export interface MirRuleCreateRequest {
	name: string;
	companyId: string;
	active: boolean;
	assets: string[];
	excludeZones: RuleZone[];
	timezone?: string;
	tripStart: TripStartOrEnd;
	tripEnd: TripStartOrEnd;
}

export interface Category {
	color: string;
	companyId: string;
	created: string;
	divisions: string[];
	id: string;
	managedEntity?: any;
	modified: string;
	name: string;
	status: "ACTIVE" | "INACTIVE";
	type: string;
	visible: boolean;
}

export interface DeleteRulesBody {
	companyId: string;
	ruleIds: string[];
}
